import { create, tsx } from '@dojo/framework/core/vdom';
import { RenderResult } from '@dojo/framework/core/interfaces';

import * as css from './SpeechBubble.m.css';

const factory = create().children<{
	main: RenderResult;
	subtitle1?: RenderResult;
	subtitle2?: RenderResult;
}>();
const SpeechBubble = factory(function SpeechBubble({ children }) {
	const [{ main, subtitle1, subtitle2 }] = children();
	return (
		<div classes={[css.root]}>
			<div classes={css.bubble}>
				<div classes={[css.quote, css.quoteTop]}></div>
				<div classes={[css.quote, css.quoteBottom]}></div>
				<div>{main}</div>
				{subtitle1 && <div classes={css.quoteSubtitle1}>{subtitle1}</div>}
				{subtitle2 && <div classes={css.quoteSubtitle2}>{subtitle2}</div>}
			</div>
		</div>
	);
});

export default SpeechBubble;
